import Loader2 from 'assets/img/loader2.png';
import { memo } from 'react';

type LoadingCustomTypes = {
  style?: React.CSSProperties,
  customClassName?: string,
};

function LoadingCustom({ style = {}, customClassName = '' } : LoadingCustomTypes) {
  return (
    <div className={`layoutLoading tw-w-full tw-flex tw-justify-center tw-items-center ${customClassName}`} style={style}>
      <img src={Loader2} alt="loader.jpg" style={{ width: '20px' }} />
    </div>
  );
}

export default memo(LoadingCustom);
